export const dataTechLanguages = [
  {
    id: 1,
    tech: "HTML5",
  },
  {
    id: 2,
    tech: "CSS3, SCSS",
  },
  {
    id: 3,
    tech: "JavaScript (ES6, TypeScript)",
  },
  
];

export const dataLibs = [
  {
    id: 1,
    tech: "React (Router, Redux, Gatsby, Native)",
  },
  {
    id: 2,
    tech: "Next.js (Prisma/PostgreSQL, Mongoose/MongoDB)",
  },
  {
    id: 3,
    tech: "Node.js (Express, Mongoose/Prisma, JWT, Redis)",
  },
  {
    id: 4,
    tech: "Lucia-auth, Clerk, Auth.js, Auth0",
  },
  {
    id: 5,
    tech: "Axios, React Query, GraohQL"
  },
  {
    id: 6,
    tech: "Shadcn/ui, DaisyUi, Bootstrap",
  },
  {
    id: 7,
    tech: "Styled-Components, Tailwind, GSAP",
  },
  {
    id: 8,
    tech: "JQuery"
  },
  {
    id: 9,
    tech: "Socket.io"
  },
];

export const dataAdditional = [
  {
    id: 1,
    tech: "GitHub",
  },
  {
    id: 2,
    tech: "Docker-Kubernetes, CI/CD"
  },
{
    id: 3,
    tech: "AWS(ECS, ECR, EC2, S3, R53, EKS, RDS, DocumentDB)",
  },

  {
    id: 4,
    tech: "Atlas, Neon",
  },
  {
    id: 5,
    tech: "Postman",
  },
  
  {
    id: 6,
    tech: "Stripe, PayPal",
  },
  {
    id: 7,
    tech: "Vegas Pro, Photoshop, Canva",
  },
  {
    id: 8,
    tech: "Expo, Android Studio",
  },
];
